import { cn } from "@lib/cn";
import { memo } from "react";
import { makeMediaLibLogoElement } from "../../../utils";
import { LOGO_FINDER_COLS, LOGO_FINDER_GAPS } from "../contants";
import { useMediaLibLogoFinderCtx } from "../ctx";
import type { IMediaLibLogo } from "../types";
import { LogoFinderLogo } from "./logo-finder-logo";

interface IProps {
  className?: string;
}

export const LogoFinderGrid = ({ className }: IProps) => {
  const { logosData } = useMediaLibLogoFinderCtx();

  return (
    <div
      className={cn("tw-grid tw-content-start", className)}
      style={{
        gap: LOGO_FINDER_GAPS,
        gridTemplateColumns: `repeat(${LOGO_FINDER_COLS}, 1fr)`,
      }}
    >
      {logosData.map((logo, idx) => {
        return (
          <Wrapper key={logo.src} logoData={logo}>
            <LogoFinderLogo idx={idx} logoData={logo} />
          </Wrapper>
        );
      })}
    </div>
  );
};

const Wrapper = memo(
  ({
    children,
    logoData,
  }: {
    children: React.ReactNode;
    logoData: IMediaLibLogo;
  }) => {
    const { elementWrapper } = useMediaLibLogoFinderCtx();
    if (!elementWrapper) return <>{children}</>;
    const ElementWrapper = elementWrapper;

    return (
      <ElementWrapper
        element={makeMediaLibLogoElement({
          src: logoData.src,
          alt: logoData.alt,
          shouldUpload: true,
        })}
      >
        {children}
      </ElementWrapper>
    );
  },
);
